import React, { useEffect, useState } from "react";
import H2HTable from "../common/table/H2HTable";
import PredictionBox from "../football/match/PredictionBox";
import NoDataFound from "../common/NoDataFound";
import { loadStyles } from "../../utils/cssLoader";

const BasketballH2H = ({
  data,
  loadCSS = true,
  dataClient = false,
  title,
  sport = "basketball",
}) => {
  const [clientData, setClientData] = useState(null);
  const [activeTab, setActiveTab] = useState("meetings");

  useEffect(() => {

    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS) {
      loadStyles("h2h");
      loadStyles("basketballh2h");
    }
  }, [loadCSS]);

  const h2hData = dataClient ? clientData : data;
  console.log(clientData, data)
  // Set initial active tab based on available data
  useEffect(() => {
    if (h2hData) {
      if (h2hData?.h2h?.length) {
        setActiveTab("meetings");
      } else if (h2hData?.home_team?.team) {
        setActiveTab("home");
      } else if (h2hData?.away_team?.team) {
        setActiveTab("away");
      }
    }
  }, [h2hData]);

  if (!h2hData) {
    return <NoDataFound />;
  }

  const getTableProps = () => {
    switch (activeTab) {
      case "meetings":
        return {
          data: h2hData?.h2h,
          plays: false,
          team: "",
          team_id: "",
        };
      case "home":
        return {
          data: h2hData?.home_team?.tournament,
          plays: true,
          team: h2hData?.home_team?.team,
          team_id: h2hData?.home_team?.id,
        };
      case "away":
        return {
          data: h2hData?.away_team?.tournament,
          plays: true,
          team: h2hData?.away_team?.team,
          team_id: h2hData?.away_team?.id,
        };
      default:
        return { data: null, plays: false, team: "" };
    }
  };

  const tableProps = getTableProps();

  return (
    <div className="basketball_h2h_container">
      {title && <h1>{title}</h1>}

      <nav className="inner_tab">
        <ul>
          {h2hData?.h2h?.length > 0 && (
            <li
              className={activeTab === "meetings" ? "active" : ""}
              onClick={() => setActiveTab("meetings")}
            >
              <a href="#">H2H</a>
            </li>
          )}
          {h2hData?.home_team?.team && (
            <li
              className={activeTab === "home" ? "active" : ""}
              onClick={() => setActiveTab("home")}
            >
              <a href="#">{h2hData?.home_team?.team}</a>
            </li>
          )}
          {h2hData?.away_team?.team && (
            <li
              className={activeTab === "away" ? "active" : ""}
              onClick={() => setActiveTab("away")}
            >
              <a href="#">{h2hData?.away_team?.team}</a>
            </li>
          )}
        </ul>
      </nav>

      <H2HTable {...tableProps} sport={sport} />

      {h2hData?.h2h_stats?.wins && h2hData?.h2h_stats?.draws && (
        <PredictionBox
          title="Match"
          drawLable={true}
          t1Score={h2hData?.h2h_stats?.wins?.t1}
          t2Score={h2hData?.h2h_stats?.wins?.t2}
          t1P={h2hData?.h2h_stats?.wins?.t1p}
          t2P={h2hData?.h2h_stats?.wins?.t2p}
          drawScore={h2hData?.h2h_stats?.draws?.tot}
          drawP={h2hData?.h2h_stats?.draws?.perct}
        />
      )}

      {h2hData?.h2h_stats?.ht_leading && (
        <PredictionBox
          title="Leading At HT"
          t1Score={h2hData?.h2h_stats?.ht_leading?.t1}
          t2Score={h2hData?.h2h_stats?.ht_leading?.t2}
          t1P={h2hData?.h2h_stats?.ht_leading?.t1p}
          t2P={h2hData?.h2h_stats?.ht_leading?.t2p}
        />
      )}

      {h2hData?.h2h_stats?.ht_drawing && (
        <PredictionBox
          title="Drawing At HT"
          t1Score={h2hData?.h2h_stats?.ht_drawing?.t1}
          t2Score={h2hData?.h2h_stats?.ht_drawing?.t2}
          t1P={h2hData?.h2h_stats?.ht_drawing?.t1p}
          t2P={h2hData?.h2h_stats?.ht_drawing?.t2p}
        />
      )}

      {h2hData?.h2h_stats?.ht_losing && (
        <PredictionBox
          title="Losing At HT"
          t1Score={h2hData?.h2h_stats?.ht_losing?.t1}
          t2Score={h2hData?.h2h_stats?.ht_losing?.t2}
          t1P={h2hData?.h2h_stats?.ht_losing?.t1p}
          t2P={h2hData?.h2h_stats?.ht_losing?.t2p}
        />
      )}
    </div>
  );
};

export default BasketballH2H;
